import { AnyAction, Dispatch } from 'redux'
import { unexpectedError, unexpectedResponse, unauthorizedError } from '../show-error-dialog/showErrorDialog'
import { StatusCodes } from 'http-status-codes'
import fetchJobs from '../../service/job/fetch-jobs/fetchJobs'
import { setLastRejectedJob } from '../../state/actions/dashboard/dashboard'

type props = {
  dispatch: Dispatch<AnyAction>,
  hideDialog?: boolean,
}

const INITIAL_NUMBER_OF_JOBS_REQUESTED = 100

const fetchAndSetLastRejectedJob = async ({ dispatch, hideDialog }: props) => {
  try {
    // The fetchJobs API does not support sorting. So we cannot assume any kind of order in the response.
    // Let's get all the rejected jobs, sort them and use the last one.
    // But fetchJobs requires we pass how many jobs we want to receive.
    // Let's start with INITIAL_NUMBER_OF_JOBS_REQUESTED, and if the response indicates that
    // there are actually more than that, we perform the request again, with the new number.
    // 90% of the cases will require performing just one request.
    let numberOfJobsRequested = INITIAL_NUMBER_OF_JOBS_REQUESTED
    let response = await fetchJobs(1, 'rejected', undefined, numberOfJobsRequested)
    let okResponse = (response.status === StatusCodes.OK && response.data)

    if (okResponse) {
      const amountOfRejected = ((response.data?.amounts?.find(entry => entry.name === 'rejected')) || {}).count || 0

      if (amountOfRejected > numberOfJobsRequested) {
        numberOfJobsRequested = amountOfRejected
        response = await fetchJobs(1, 'rejected', undefined, numberOfJobsRequested);
        okResponse = (response.status === StatusCodes.OK && response.data)
      }
    }

    if (okResponse) {
      const sortedJobs = (response.data?.jobs || []).sort((a: any, b: any) => ((new Date(a.createdAt).valueOf()) - (new Date(b.createdAt)).valueOf()))
      const lastRejected = sortedJobs.pop()
      dispatch(setLastRejectedJob(lastRejected))
      return true
    } else {
      dispatch(unexpectedResponse())
      return false
    }
  } catch (error) {
    if (hideDialog) {
      return false
    }

    if (error.response?.status === StatusCodes.UNAUTHORIZED) {
      dispatch(unauthorizedError(dispatch))
    } else {
      dispatch(unexpectedError())
    }
  }
  return false
}

export default fetchAndSetLastRejectedJob
